// DronePage.jsx
import React from "react";
import { Link } from "react-router-dom";
import "./DronePage.css";

import bombShell from "../Assessts/DroneImages/1drone.png";
import universalTestRig from "../Assessts/DroneImages/2drone.png";
import universalTestRi from "../Assessts/DroneImages/3VymanikShaktiV.1Drone.png";
import universalTestR from "../Assessts/DroneImages/4drone.png";
import universalTest from "../Assessts/DroneImages/5drone.png";
import universalTes from "../Assessts/DroneImages/6drone.png";
import universalTe from "../Assessts/DroneImages/7drone.png";
import universalT from "../Assessts/DroneImages/8drone.png";
import universal from "../Assessts/DroneImages/9drone.png";
import universa from "../Assessts/DroneImages/10_3dmodelling.png";
import univers from "../Assessts/DroneImages/11_InMining.png";
import univer from "../Assessts/DroneImages/12Infrastructure_Inspection.png";

const droneProducts = [
  {
    id: 1,
    title: "Pasha V.1 Drone",
    img: bombShell,
    desc:"The anti-drone drone uses advanced detection systems and AI-driven tracking to identify, pursue, and capture rogue aerial vehicles. Once locked onto a target, it deploys a specially engineered net that safely disables and grounds the unauthorized drone—without causing harm to surrounding environments or infrastructure.  It operates in real time, responds autonomously, and scales efficiently depending on the security perimeter."
  },
  {
    id: 2,
    title: "Astra V.1 Drone",
    img: universalTestRig,
    desc: "esigned for high-value target elimination, the Astra V.1 can infiltrate enemy defenses undetected, lock onto key objectives, and execute rapid-impact missions with deadly accuracy. Its lightweight frame and streamlined build make it easy to deploy from mobile platforms, ground units, or aerial carriers while seamlessly integrating with modern command-and-control systems.",
  },
  {
    id: 3,
    title: "Shakti V.1 Drone",
    img: universalTestRi,
    desc: " This cutting-edge technology allows for safe and effective dispersal of tear gas in various situations. With its advanced navigation system and precise targeting capabilities, the drone can accurately deliver tear gas to specific areas, minimizing collateral damage and ensuring the safety of law enforcement personnel and civilians alike. The tear gas dropping drone is equipped with state-of-the-art sensors and cameras, providing real-time feedback to the operators, allowing for quick and informed decision-making.",
  },
  {
    id: 4,
    title: "BRIDGE FIRING BOX ASSEMBLY",
    img: universalTestR,
    desc: "",
  },
  {
    id: 5,
    title: "RC Trainer Drone",
    img: universalTest,
    desc: " This versatile, user-friendly drone has advanced features ensuring a smooth and stable flight experience. Its sturdy construction and durable materials make it resistant to crashes, allowing users to learn and practice without fear of damaging the drone. The intuitive remote control provides easy manoeuvrability, making it suitable for all skill levels. With its built-in camera, the Vymanik Trainer Drone allows users to capture stunning aerial photos and videos, adding an extra dimension to their flying experience.",
  },
  {
    id: 6,
    title: "PV Module Drone Thermography",
    img: universalTes,
    desc: "Our mission is to maximize the efficiency and performance of your solar installations through immediate, data-driven actions. Leveraging advanced technology and our team of highly trained experts, we provide accurate assessments that contribute to the more effective and sustainable use of solar energy. Through analysis,Advanced technology,Highly trained experts",
  },
  {
    id: 7,
    title: "Law Enforcement",
    img: universalTe,
    desc: "Police departments use drones for crime scene investigation, search and rescue operations, traffic monitoring, and crowd management. Drones equipped with thermal imaging cameras are particularly useful in locating suspects or missing persons.",
  },
  {
    id: 8,
    title: "Environmental Monitoring & Agriculture",
    img: universalT,
    desc: "Drones equipped with sensors are used for monitoring environmental parameters such as air and water quality, wildlife habitats, and natural disaster assessment. They help in gathering data for research, conservation efforts, and disaster response planning.",
  },
  {
    id: 9,
    title: "Security Survellience",
    img: universal,
    desc: "Drones are employed for monitoring and patrolling sensitive areas such as airports, borders, industrial sites, and public events. They provide real-time video feeds and can cover large areas efficiently.",
  },
  {
    id: 10,
    title: "BRIDGE FIRING BOX ASSEMBLY",
    img: universa,
    desc: "The Bridge Firing Box Assembly offers a robust and reliable ignition solution for aerospace and defense applications. Built with advanced safety measures, it ensures precise control during test firings. Its durable construction and dependable performance make it ideal for high-stakes environments where safety is paramount.",
  },
  {
    id: 11,
    title: "BRIDGE FIRING BOX ASSEMBLY",
    img: univers,
    desc: "The Bridge Firing Box Assembly offers a robust and reliable ignition solution for aerospace and defense applications. Built with advanced safety measures, it ensures precise control during test firings. Its durable construction and dependable performance make it ideal for high-stakes environments where safety is paramount.",
  },
  {
    id: 12,
    title: "BRIDGE FIRING BOX ASSEMBLY",
    img: univer,
    desc: "The Bridge Firing Box Assembly offers a robust and reliable ignition solution for aerospace and defense applications. Built with advanced safety measures, it ensures precise control during test firings. Its durable construction and dependable performance make it ideal for high-stakes environments where safety is paramount.",
  },
];

export default function DronePage() {
  return (
    <div
      style={{
        background:
          // "linear-gradient(135deg, rgba(28, 29, 31, 0.95), rgba(255, 255, 255, 0.9))",
          "white"
      }}
    >
      <h2
        style={{
          fontWeight: 600,
          textAlign: "center",
          marginBottom: "50px",
          paddingTop: "50px",
          // color: "white",
          color: "#074f86ff",
        }}
      >
        DRONES
      </h2>

      <div className="drone-grid">
        {droneProducts.map((item) => (
          <div className="drone-card" key={item.id}>
            <img
              src={item.img}
              alt={item.title}
              style={{ height: "250px", width:"500px", objectFit: "cover" }}
            />
            <div className="drone-title">{item.title}</div>

            {/* description overlay appears only on hover */}
            <div className="drone-hover-desc">
              <p>{item.desc}</p>
              <Link to={`/viewDrone/${item.id}`} className="drone-view-btn">
                View Product
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export { droneProducts };
